export default "__VITE_ASSET__2$VYJxW6__"